/**
 * A training document's metadata, as returned by the Resort Tools API's GET /training/documents.
 * The file bytes themselves come from GET /training/documents/{id}/content.
 */
export interface TrainingDocument {
  id: number;
  title: string;
  fileName: string;
  contentType: string;
  sizeBytes: number;
  sortOrder?: number;
  uploadedBy: string;
  createdUtc: string;
  updatedUtc?: string;
}


/**
 * Sorts documents the way the API lists them: ascending sortOrder with unset values last, then title.
 */
export const sortTrainingDocuments = (documents: TrainingDocument[]): TrainingDocument[] =>
  [ ...documents ].sort((a, b) =>
    (a.sortOrder ?? Number.MAX_SAFE_INTEGER) - (b.sortOrder ?? Number.MAX_SAFE_INTEGER)
    || a.title.localeCompare(b.title, undefined, { sensitivity: 'base' }));
